/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.button`
	background: transparent;
	border: none;
	display: inline-block;
	width: 30px;
	height: 30px;
	border-radius: 50%;
`;


// WEBPACK FOOTER //
// ./src/components/general/button-round.js